import { Logger } from "@jetjs/utils";
import { AliasAstExtensionVisitor } from "../parser/visitor/AliasAstExtensionVisitor";
import { DefaultWalker } from "../parser/visitor/DefaultWalker";
import { LoadPluginVisitor } from "../parser/visitor/LoadPluginVisitor";
import { PluginExecutionVisitor } from "../parser/visitor/PluginExecutionVisitor";
import { PluginRegistry } from "./PluginRegistry";
/**
 * @public
 */
export class PluginExecutor {
    constructor(pool, loader) {
        this.walker = new DefaultWalker();
        this.loader = loader;
        this.threadPool = pool;
        const r = PluginRegistry.getInstance();
        this.loadPluginVisitor = new LoadPluginVisitor(this.loader);
        this.executionVisitor = new PluginExecutionVisitor(this.threadPool, r);
        this.astExtensionVisitor = new AliasAstExtensionVisitor(r);
    }
    execute(node, pluginDefs) {
        // load plugins
        this.loadPluginVisitor.reset();
        this.walker.walk(pluginDefs, this.loadPluginVisitor);
        const loadingPromises = this.loadPluginVisitor.getLoadingPromises();
        Promise.all(loadingPromises)
            .then(() => this.executePlugins(node, pluginDefs))
            .catch(err => {
            // log an error for debugging purposes (will be stripped out for production builds). We can't throw the error,
            // because we want to try to execute the other plugins, that are loaded successfully
            Logger.error("Error while loading Plugins: ", err);
            // we try to execute the plugins, even if some plugins might have failed to load
            this.executePlugins(node, pluginDefs);
        });
    }
    /**
     * if this method is called, we assume that all plugins are loaded
     */
    executePlugins(node, pluginDefs) {
        /**
         * Extension: ?
         *
         * save stream reference to weak map, so we can call the stream later programmatically.
         * If a node will be removed, it will be removed from the WeakMap too, so its the perfect Collection-Type,
         * because we don't need to care about cleanup.
         *
         * This Feature can be used to define "sub-streams" on data attributes like
         *    <div id="myElement" data-my-custom-plugin-pipe="operator | subscriber"> ... </div>
         * These Streams start without an Observable. The Observable is defined on another Element like:
         *    <div data-plugins="observable | operator | streamDelegate"
         *         data-stream-delegate-selector="#myElement"
         *         data-stream-delegate-stream="myCustomPluginPipe"> ... </div>
         * The streamDelegate Plugin acts like a subscriber (to start the stream). All received values will be forwarded to the specified Stream
         * on the Element(s) which matches the given selector.
         *
         * To do the delegation, we need a reference...
         *
         * But we should try to implement the StreamDelegate as external Plugin.
         * So we must provided a public accessible parse and execute Methods, that returns the Stream reference.
         */
        this.executionVisitor.init(node);
        pluginDefs.forEach(p => {
            // execute each plugin definition on its own.
            // So we can catch errors for every definition on its own, to execute as much definitions as possible.
            try {
                // handle alias and plugin Chain definitions. (They will be replaced by real plugins in the AST)
                this.walker.walkPluginDefinition(p, this.astExtensionVisitor);
                // execute plugins
                this.walker.walkPluginDefinition(p, this.executionVisitor);
            }
            catch (err) {
                Logger.error(err);
            }
        });
    }
}
//# sourceMappingURL=PluginExecutor.js.map